import React from 'react';
import styles from './Footer.module.css';
import logo from '../../assets/logo-white.svg'
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate('/reservation')
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        {/* Top Navigation Bar */}
        <nav className={styles.topNav}>
          <a href="/about">About Us</a>
          <a href="/menu">Menu</a>
          <a href="/events">Events</a>
          <a href="/gallery">Gallery</a>
          <a href="/career">Career</a>
          <a href="/contact">Contact Us</a>
        </nav>

        {/* Main Content Grid */}
        <div className={styles.mainGrid}>

          {/* Logo Section */}
          <div className={styles.logoCol}>
            <img src={logo} alt="Bağlami by Dimora" className={styles.logo} />
          </div>

          {/* Address Section */}
          <div className={styles.infoCol}>
            <h3>Our Address</h3>
            <p>Bağlami, Bombay @ BKC 7, Ins Tower, Opp NMACC, Bandra Kurla Complex, Mumbai, Maharashtra 400098</p>
            <p className={styles.phone}> 8879199982, &#10240;  8879199984</p>
            <a href="#direction" className={styles.link} onClick={() => { window.open('https://maps.app.goo.gl/pQDcszsiSsEh5LEd6') }}>
              Get a direction <span className={styles.arrow}>↘</span>
            </a>
          </div>

          {/* Hours Section */}
          <div className={styles.infoCol}>
            <h3>Hours</h3>
            <p><strong>Seating From:</strong></p>
            <p>12pm–4pm</p>
            <p>07pm–1:30am</p>
            {/* <a href="#more" className={styles.link}>
              Learn more <span className={styles.arrow}>↘</span>
            </a> */}
          </div>

          {/* Socials & Button Section */}
          <div className={styles.socialCol}>
            <h3>Socials</h3>
            <div className={styles.socialLinks}>
              <a target="_blank" rel="noreferrer" href="https://www.instagram.com/baglamibombay/">Instagram</a>
              {/* <a href="https://facebook.com">Facebook</a> */}
            </div>
            <button onClick={handleNavigate} className={styles.reservationBtn}>Reservation</button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={styles.bottomBar}>
          <p>© Copyright {currentYear}. . All rights reserved.</p>
          <div className={styles.legalLinks}>
            <a target="_blank" rel="noreferrer" href="/BaglamiPolicy.pdf">Terms & Conditions</a>
            <a target="_blank" rel="noreferrer" href="/BaglamiPolicy.pdf">Privacy Policy</a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;